/** Renders a shortcut like "g i" or "mod+k" as key caps. */
export function Kbd({ keys }: { keys: string }) {
  const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);
  const parts = keys.split(" ").map((chord) =>
    chord
      .split("+")
      .map((k) => (k === "mod" ? (isMac ? "⌘" : "Ctrl") : k === "shift" ? "⇧" : k === "alt" ? (isMac ? "⌥" : "Alt") : k))
      .join(isMac ? "" : "+"),
  );
  return (
    <span className="chrome" style={{ display: "inline-flex", gap: 3 }}>
      {parts.map((p, i) => (
        <kbd key={i}>{p}</kbd>
      ))}
    </span>
  );
}
